<template src="./Cards.html"></template>
<script>
import moment from "moment";
import mixins from "../../../../../Mixins.js";
export default {
  mixins: [mixins],
  data() {
    return {
      cards: [],
      selected: [],
      cardsCount: 0,
      searchCards: "",
      currentx: 1,
      numPages: 0,
      pagination: false,
      windowWidth: 0,
    };
  },
  mounted: function() {
    const vm = this;
    vm.init();
  },
  created() {
    const vm = this;
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  watch: {
    cards: function(newVal){
      const vm = this;
      vm.cards = newVal;
    },
    currentx: function () {
      const vm = this;
      vm.changePagination();
    },
  },
  methods: {
    init() {
      const vm = this;
      vm.getCards();
    },
    changeSearchCards() {
      const vm = this;
      setTimeout(() => {
        vm.$vs.loading();
        vm.getCards();
      }, 2000);
      
    },
    getCards() {
      const vm = this;
      const page = vm.currentx - 1;
      vm.$vs.loading();
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "admin/sheet-cards?page=" + page + "&search=" +
            vm.searchCards +
            "&size=10&sort=id,desc",
          {
            headers: {
              Authorization: vm.$session.get("bearerDefault")
            }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.cards = response.data.content;
            vm.cardsCount = response.data.totalElements;
            vm.numPages = response.data.totalPages;
            vm.pagination = vm.numPages > 1;
            vm.fillCards();
          }
        });
    },
    formatDate(date){
      const vm = this;
     if(vm.testNullUndefinedEmpty(date)){
       return "Sem registro";
     } else {
       let dateFormat = moment(date).format("DD/MM/YYYY hh:mm:ss");
      return dateFormat;
     }
    },
    download(id, name) {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "admin/sheet-cards/" +
            id +
            "/download/" + name,
          {
            headers: { Authorization: vm.$session.get("bearerDefault") },
            responseType: 'blob'
          }
        )
        .then(function(response) {
          if(response.status === 200){
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", name + ".xlsx");
            document.body.appendChild(link);
            link.click();
          }
        });
    },
    fillCards() {
      const vm = this;
      for(let c in vm.cards){
        vm.cards[c].createDate = vm.formatDate(vm.cards[c].uploadRegister.createDate);
        if(vm.testNullUndefinedEmpty(vm.cards[c].fileName)){
          if(vm.testNullUndefinedEmpty(vm.cards[c].uploadRegister.excelFilename)){
            vm.cards[c].fileName = "Sem registro";
          } else {
            vm.cards[c].fileName = vm.cards[c].uploadRegister.excelFilename;
          }
        } else {
          vm.cards[c].fileName = vm.cards[c].fileName;
        }
      }
      vm.$vs.loading.close();
    },
    changePagination(){
      const vm = this;
      vm.getCards();
    },
    handleResize() {
      const vm = this;
      vm.windowWidth = window.innerWidth;
    },
  }
};
</script>

<style lang="scss" src="./Cards.scss">
</style>
